import * as React from "react";

import { ImageComponent } from "@app/core";
import { ClickableComponent } from "@app/core/clickable";

import styles from "./cta-small-component.module.scss";

export interface ICtaSmallComponentProps {
  buttonTitle?: string;
  ctaText?: string;
  href?: string;
  icon?: any;
  onClick?: () => void;
}

const CtaSmallComponent = (props: ICtaSmallComponentProps) => {
  const { buttonTitle, href, icon, onClick, ctaText } = props;

  return (
    <div className={styles.root}>
      <div className="uk-container">
        <div className={styles.inner}>
          {icon && (
            <div className={styles.icon}>
              <ImageComponent src={icon} />
            </div>
          )}
          <div className={styles.title}>{ctaText}</div>
          {buttonTitle && (
            <ClickableComponent href={href} onClick={onClick} title={buttonTitle} variant="primary-2025-black" />
          )}
        </div>
      </div>
    </div>
  );
};

export { CtaSmallComponent };
